export const headerConfig = [{
    name: 'title',
    value: 'ad.title',
    width: 246,
}, {
    name: 'status',
    value: 'ad.status',
    width: 105,
}, {
    name: 'valid_from',
    value: 'ad.valid_from',
    width: 363,
}, {
    name: 'valid_to',
    value: 'ad.valid_to',
    width: 363,
}, {
    name: 'publish_time',
    value: 'ad.publish_time',
    width: 363,
}];

